const px = (url, w = 1400) => `${url}?auto=compress&cs=tinysrgb&w=${w}`;
const us = (url, w = 1400) => `${url}?auto=format&fit=crop&w=${w}&q=80`;

export const SCENES = {
  heroWaterfall: px("https://images.pexels.com/photos/14982348/pexels-photo-14982348.jpeg", 1920),
  waterfallAlt: px("https://images.pexels.com/photos/5046379/pexels-photo-5046379.jpeg", 1400),
  irishHills: px("https://images.pexels.com/photos/14140157/pexels-photo-14140157.jpeg", 1920),
  irishFields: px("https://images.pexels.com/photos/4350780/pexels-photo-4350780.jpeg", 1400),
  mistyPeak: us("https://images.unsplash.com/photo-1540979388789-6cee28a1cdc9", 1920),
  candles: px("https://images.pexels.com/photos/15211704/pexels-photo-15211704.jpeg", 1200),
  paper: us("https://images.unsplash.com/photo-1705837863332-7162639852d8", 1200),
  waxLetters: us("https://images.unsplash.com/photo-1774891937498-6020acda63f3", 1200),
};

export const ERAS = {
  vintage1919: px("https://images.pexels.com/photos/4612033/pexels-photo-4612033.jpeg", 1600),
  vintageChild: px("https://images.pexels.com/photos/4352446/pexels-photo-4352446.jpeg", 1600),
  sepiaStreet: us("https://images.unsplash.com/photo-1780245692145-c3af526ee068", 1920),
  sepiaStreet2: us("https://images.unsplash.com/photo-1697919046731-6474a584cc20", 1920),
  fifties: px("https://images.pexels.com/photos/9247575/pexels-photo-9247575.jpeg", 1600),
  aiFuture: px("https://images.pexels.com/photos/14314636/pexels-photo-14314636.jpeg", 1600),
  aiFuture2: px("https://images.pexels.com/photos/14314638/pexels-photo-14314638.jpeg", 1600),
};

export const AGNES = {
  hero: "/images/agnes-sunglasses.jpg",
  sunglasses: "/images/agnes-sunglasses.jpg",
  real: "/images/agnes-real.jpg",
  boxing1: "/images/agnes-boxing-gloves-1.jpg",
  boxing2: "/images/agnes-boxing-gloves-2.jpg",
  family: "/images/agnes-family-bw.jpg",
  birthday103: "/images/agnes-103rd-birthday.jpg",
  birthday104: "/images/agnes-104th-birthday.jpg",
  birthday105: "/images/agnes-105th-birthday.jpg",
};

export const ROYAL = {
  queenElizabeth: "/images/royal-letter-queen-elizabeth.jpg",
  kingCharles: "/images/royal-letter-king-charles.jpg",
  certificates100: "/images/agnes-100th-certificates.jpg",
  governorGeneral: "/images/agnes-governor-general-letter.jpg",
  primeMinister: "/images/agnes-pm-letter.jpg",
};

export const VIDEOS = [
  {
    externalUrl: "https://www.cbc.ca/listen/live-radio/1-52-radio-active/clip/16233483-edmontonian-celeb",
    poster: "/images/agnes-107th-birthday-04.jpg",
    title: "Edmontonian celebrates 107th birthday",
    year: "2026",
    source: "CBC Radio Active",
    externalLabel: "Listen on CBC",
    description: "Agnes Murphy’s 107th birthday celebration featured on CBC Radio Active.",
  },
  {
    externalUrl: "https://www.ctvnews.ca/edmonton/video/2026/08/24/edmonton-woman-celebrates-107th-birthday/",
    poster: "/images/agnes-107th-birthday-04.jpg",
    title: "Edmonton woman celebrates 107th birthday",
    year: "August 24, 2026",
    source: "CTV News Edmonton",
    externalLabel: "Watch on CTV News",
    description: "Agnes Murphy celebrated her 107th birthday with five generations of her family.",
  },
  {
    src: "/videos/happy-birthday.mp4",
    poster: "/images/agnes-real.jpg",
    title: "Happy Birthday Agnes!",
    year: "2026",
  },
  {
    src: "/videos/grannys-city-council.mp4",
    poster: "/images/agnes-governor-general-letter.jpg",
    title: "City Council Recognition",
    year: "2025",
  },
  {
    src: "/videos/birthday-vid.mp4",
    poster: "/images/agnes-backyard-family.jpg",
    title: "Birthday Celebration",
    year: "2026",
  },
];

export const GALLERY = [
  { src: "/images/agnes-107th-birthday-01.jpg", caption: "On the way to celebrate",          year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-02.jpg", caption: "Birthday flowers",                 year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-03.jpg", caption: "A birthday morning",                year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-04.jpg", caption: "Celebrating Agnes at 107",         year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-05.jpg", caption: "Family celebration",                year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-06.jpg", caption: "Surrounded by loved ones",          year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-07.jpg", caption: "A special birthday gathering",     year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-08.jpg", caption: "Together for Agnes",                year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-09.jpg", caption: "107 years of memories",             year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-10.jpg", caption: "A joyful celebration",              year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-11.jpg", caption: "Birthday smiles",                   year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-12.jpg", caption: "Making memories together",          year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-13.jpg", caption: "A day to remember",                 year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-14.jpg", caption: "Love all around",                   year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-15.jpg", caption: "A beautiful birthday moment",       year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-16.jpg", caption: "Celebrating 107 wonderful years",   year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-17.jpg", caption: "Birthday memories",                 year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-18.jpg", caption: "A warm birthday welcome",           year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-19.jpg", caption: "Family and friends together",       year: "August 22, 2026" },
  { src: "/images/agnes-107th-birthday-20.jpg", caption: "The celebration continues",         year: "August 22, 2026" },
  { src: "/images/agnes-boxing-gloves-1.jpg","caption": "Still fighting — at 107!",         year: "2026"     },
  { src: "/images/agnes-boxing-gloves-2.jpg","caption": "A champion spirit",                year: "2026"     },
  { src: "/images/agnes-with-visitor-1.jpg", caption: "Always welcoming",                   year: "2026"     },
  { src: "/images/agnes-with-visitor-2.jpg", caption: "Cheek to cheek",                     year: "2026"     },
  { src: "/images/agnes-outdoor-party.jpg",  caption: "Celebrating outside with family",    year: "2026"     },
  { src: "/images/agnes-outdoor-smile.jpg",  caption: "That smile never gets old",          year: "2026"     },
  { src: "/images/agnes-gift-from-grandson.jpg", caption: "A gift from a young fan",        year: "2026"     },
  { src: "/images/agnes-backyard-family.jpg",  caption: "Backyard love — three generations", year: "2026"     },
  { src: "/images/agnes-with-grandson-glasses.jpg", caption: "Agnes & her great-grandson",  year: "2026"     },
  { src: "/images/agnes-with-grandson-hug.jpg",     caption: "A warm embrace",              year: "2026"     },
  { src: "/images/agnes-big-hug.jpg",               caption: "The best kind of hug",        year: "2026"     },
  { src: "/images/agnes-real.jpg",           caption: "Agnes Murphy",                       year: "c. 1980s" },
  { src: "/images/agnes-1930s-garden.jpg",   caption: "Young Agnes in the garden",          year: "c. 1930s" },
  { src: "/images/agnes-1940s-family-portrait.jpg", caption: "A family portrait",            year: "c. 1940s" },
  { src: "/images/agnes-1950s-family.jpg",   caption: "Three generations",                  year: "c. 1950s" },
  { src: "/images/agnes-1950s-winter.jpg",   caption: "A winter's day",                     year: "c. 1950s" },
  { src: "/images/agnes-1960s-couple.jpg",   caption: "Agnes & her love",                   year: "c. 1960s" },
  { src: "/images/agnes-garden-2015.jpg",    caption: "A summer afternoon",                 year: "c. 2015"  },
  { src: "/images/agnes-birthday-2017.jpg",  caption: "Celebrating with family",            year: "2017"     },
  { src: "/images/agnes-family-bw.jpg",      caption: "Surrounded by generations",          year: "c. 2020"  },
  { src: "/images/agnes-103rd-birthday.jpg", caption: "103rd birthday party",               year: "2022"     },
  { src: "/images/agnes-104th-party.jpg",    caption: "104th birthday — purple & balloons", year: "2023"     },
  { src: "/images/agnes-104th-birthday.jpg", caption: "104th birthday with family",         year: "2023"     },
  { src: "/images/agnes-105th-birthday.jpg", caption: "105th birthday celebration",         year: "2024"     },
  { src: "/images/agnes-105th-with-family.jpg", caption: "105th — five generations gathered", year: "2024"  },
  { src: "/images/agnes-106th-family.jpg",   caption: "With the grandchildren, 106th",      year: "2025"     },
  { src: "/images/agnes-106th-laughing.jpg", caption: "That laugh — pure joy",              year: "2025"     },
];
